import { DOCUMENT } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { CoachProfileInformationController } from 'presentation/page/profile/coach-profile/coach-profile-information/coach-profile-information.controller';
import { IUser } from 'user/user';

@Component({
	selector: 'spr-coach-profile-information',
	templateUrl: './coach-profile-information.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachProfileInformationController],
	host: {
		class: 'h-full w-full xl:w-4/6',
	},
})
export class CoachProfileInformationComponent {
	@Input() public coach: IUser;
	public picturePlaceholder = environment.profilePlaceholder;
	public showMeetingButton$: Observable<boolean>;

	constructor(
		private _controller: CoachProfileInformationController,
		@Inject(DOCUMENT) private _document: Document,
		private _translateService: TranslateService
	) {
		this.showMeetingButton$ = _controller.showMeetingButton$;
	}

	public onSendEmailClick(email: string): void {
		this._document.location.href = `mailto:${email}?subject=${this._translateService.instant(
			'presentation.app.page.profile.coach.sendMail.mailDefaultSubject'
		)}`;
	}
}
